import filterStyles from "../filters/FilterPanel.module.css";
import useYearRange from "../../hooks/useYearRange";

type Props = {
  filterOptions: any;
  globalFilters: any;
  updateFilter: (key: string, value: any, target?: any) => void;
  targetChart?: any;
};

const YearRangeSelector = ({ filterOptions, globalFilters, updateFilter, targetChart }: Props) => {
  const { startOptions, endOptions, startValue, endValue } = useYearRange(
    filterOptions,
    globalFilters
  );

  return (
    <div>
      <div className={filterStyles.inputGroup}>
        <select
          value={startValue}
          onChange={(e) =>
            updateFilter(
              "yearRange",
              [
                Math.min(parseInt(e.target.value || "0", 10), globalFilters.yearRange[1] - 1),
                globalFilters.yearRange[1],
              ],
              targetChart
            )
          }
          className={filterStyles.inputSmall}
          disabled={startOptions.length === 0}
        >
          {startOptions.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
        <span className={filterStyles.textMuted}>to</span>
        <select
          value={endValue}
          onChange={(e) =>
            updateFilter(
              "yearRange",
              [
                globalFilters.yearRange[0],
                Math.max(parseInt(e.target.value || "0", 10), globalFilters.yearRange[0] + 1),
              ],
              targetChart
            )
          }
          className={filterStyles.inputSmall}
          disabled={endOptions.length === 0}
        >
          {endOptions.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default YearRangeSelector;
